/**
 * @file
 * Global VUE Components
 * Used in library: vue
 *
 * Use this file to register components globally
 * This configuration will be set in @/bootstrap/app.ts
 */

import {ComponentOptions} from 'simpli-web-sdk'

import Multiselect from 'vue-multiselect/src/Multiselect.vue'
import ItDisplay from '@/components/itrack/ItDisplay.vue'
import ItTable from '@/components/itrack/ItTable.vue'
import ItRender from '@/components/itrack/ItRender.vue'
import ItMap from '@/components/itrack/ItMap.vue'
import ItSearch from '@/components/itrack/ItSearch.vue'

/**
 * Global VUE Components
 */
export const components: ComponentOptions = {
  Multiselect,
  ItDisplay,
  ItTable,
  ItRender,
  ItMap,
  ItSearch,
}
